<div class="section-title">
  <h2>{{ title | translate }}</h2>
  @if (displayTooltip()) {
    <app-more-info-tooltip
      [titleTooltip]="titleTooltip"
      [message]="message"
      [isInnerHTML]="true"
      [contentTemplateRef]="tooltipContentRef"
      >
    </app-more-info-tooltip>
  }
</div>
